import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupproduct'
})
export class GroupproductPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
